module.exports = __webpack_public_path__ + "static/media/icon.contact.3fa53f63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon.contact.svg
// module id = 258
// module chunks = 0